var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('canvas',{attrs:{"id":"canvas"},on:{"mouseenter":function($event){return _vm.changeOn()},"mouseleave":function($event){return _vm.changeOff()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }